import type { HTMLAttributes } from 'react';

import { cn } from './cn';

export type AlertTone = 'info' | 'success' | 'warning' | 'danger';

const toneStyles: Record<AlertTone, string> = {
  info: 'bg-cream-100 text-ink-700 ring-burgundy-500/10',
  success: 'bg-leaf/10 text-ink-900 ring-leaf/30',
  warning: 'bg-sun-500/10 text-ink-900 ring-sun-500/30',
  danger: 'bg-red-50 text-red-700 ring-red-200',
};

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  tone?: AlertTone;
}

export function Alert({ tone = 'info', className, role = 'alert', ...rest }: AlertProps) {
  return (
    <div
      role={role}
      className={cn('rounded-2xl px-4 py-3 text-sm ring-1', toneStyles[tone], className)}
      {...rest}
    />
  );
}
